var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "my_slider_layer m-lr-11",
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.title
        ? _c("span", {
            staticClass: "title slider-title",
            style: { width: _vm.titleWidth + "px" },
            domProps: { textContent: _vm._s(_vm.title) },
          })
        : _vm._e(),
      _c(
        "p",
        { class: _vm.type === "one_level" ? "set_one_level" : "set_two_level" },
        [
          _c("el-slider", {
            staticClass: "slider_style",
            staticStyle: { width: "200px", "margin-right": "8px" },
            attrs: {
              min: _vm.min,
              max: _vm.max,
              step: _vm.step,
              disabled: _vm.disabled,
              "show-tooltip": false,
            },
            on: { change: _vm.change },
            model: {
              value: _vm.Result,
              callback: function ($$v) {
                _vm.Result = $$v
              },
              expression: "Result",
            },
          }),
          _c("my_input_number", {
            staticClass: "slider-input",
            attrs: {
              titleWidth: "0",
              value: _vm.inputResult,
              min: _vm.min,
              max: _vm.max,
              size: "small",
              "num-type": _vm.numType,
              step: _vm.step,
              symbol: _vm.symbol,
              width: "56",
              precision: _vm.precision,
            },
            on: {
              "update:value": function ($event) {
                _vm.inputResult = $event
              },
              change: _vm.change_input,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }